import { organizationUserQueryKeys } from "@/api/query-keys/organizations"
import ScreenWrapper from "@/components/ScreenWrapper"
import { OrganizationUserForm } from "@/components/forms/organizationUser/OrganizationUserForm"
import { checkOrganizationPermissions } from "@/utils/checkOrganizationPermissions"
import { useQueryClient } from "@tanstack/react-query"
import { createFileRoute, useRouter } from "@tanstack/react-router"
import { FormStyle } from "toptaal-shared"

export const Route = createFileRoute("/beheer/medewerkers/aanmaken")({
  component: RouteComponent,
  beforeLoad: () => checkOrganizationPermissions("create", "contacts"),
})

function RouteComponent() {
  const router = useRouter()
  const queryClient = useQueryClient()

  const handleSuccess = () => {
    queryClient.invalidateQueries({
      queryKey: organizationUserQueryKeys.all,
    })

    router.navigate({
      to: "/beheer/medewerkers",
      replace: true,
    })
  }

  return (
    <ScreenWrapper className="mt-8" showManagementMenu>
      <FormStyle className="mx-auto">
        <h2 className="text-center text-xl mb-8">Nieuwe medewerker</h2>

        <OrganizationUserForm handleSuccess={handleSuccess} type="create" />
      </FormStyle>
    </ScreenWrapper>
  )
}
